import { Category, YSH_GTM_EVENTS } from '../types/types.ts';
import { CATEGORY_IMAGE_SOURCES } from '../constants/categories.ts';
import HeartIcon from '../assets/images/icons/icon-heart.png';
import Button from './Button.tsx';
import { useEffect } from 'react';
import { useFetchSelectedCategories } from '../hooks/useFetchSelectedCategories.ts';
import { pushToAnalytics } from '../utils/analytics.ts';

interface QuestionnaireCategoriesContentProps {
  userSelectedCategories: string[];
  setUserSelectedCategories: (categories: string[]) => void;
  handleSubmitCategories: () => void;
  categories: Category[];
}

const QuestionnaireCategoriesContent: React.FC<QuestionnaireCategoriesContentProps> = ({
  handleSubmitCategories,
  userSelectedCategories,
  setUserSelectedCategories,
  categories
}) => {
  const { data: selectedCategories } = useFetchSelectedCategories();

  const handleCategoryClick = (category: Category) => {
    if (userSelectedCategories.includes(category.id)) {
      setUserSelectedCategories(userSelectedCategories.filter(categoryId => categoryId !== category.id));
      return;
    }
    setUserSelectedCategories([...userSelectedCategories, category.id]);
  };

  useEffect(() => {
    pushToAnalytics({
      eventName: YSH_GTM_EVENTS.OPEN_QUESTIONAIRE,
      data: {}
    });

    setUserSelectedCategories(selectedCategories ?? []);
  }, [selectedCategories]);

  return (
    <>
      <div className="vertical-scroll pb-4">
        <div className="ps-2 pe-2 pt-2">
          <p className="font-yettel">Dobrodošao/la na Y. Shopping</p>
          <h2 className="font-yettel-bold  mb-2">Šta te interesuje?</h2>
          <p className="font-yettel">Izaberi minimum 3 omiljene kategorije za više personalizovanih ponuda.</p>
        </div>
        <div className="ps-2 pe-2 pt-2" onClick={e => e.stopPropagation()}>
          <div className="content">
            {categories?.map(category => (
              <div
                key={category.id}
                className={`${userSelectedCategories.includes(category.id) ? 'category-item category-item--active' : 'category-item'}`}
                onClick={() => handleCategoryClick(category)}
              >
                <div className="category-user-selected__image d-flex align-items-center">
                  {category?.icon && (
                    <img
                      className="category-icon"
                      src={
                        userSelectedCategories.includes(category.id) ? HeartIcon : CATEGORY_IMAGE_SOURCES[category.icon]
                      }
                      alt={category.name}
                    />
                  )}
                </div>
                <p className="font-yettel-light text-center fz-14 pt-1 mb-2">{category.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mb-2">
        <Button className="mt-2" disabled={userSelectedCategories.length < 3} onClick={handleSubmitCategories}>
          Nastavi
        </Button>
        {userSelectedCategories.length > 0 && (
          <p className="text-center fz-14 pt-2">Izabrano: {userSelectedCategories.length}</p>
        )}
      </div>
    </>
  );
};

export default QuestionnaireCategoriesContent;
